require('./updateClientContactTime.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

//@core
const { formatText } = require('core/i18n').i18n;

//@commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');

//@constants
const {
    FIRST_STEP,
    THIRD_STEP,
    WIZARD_VERTICAL_VIEW_MODE
} = require('constants/index');
const {
    PROFILE_EDIT_FORMS: {
        PHONE_CONTACT_TIME,
        EMAIL_CONTACT_TIME
    }
} = require('constants/myProfileEditor');

const { UPDATE_CLIENT_CONTACT_TIME } = require('constants/contactCenter/operationTypes');

// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const UpdateClientContactTimeStep1 = require('./steps/updateClientContactTimeStep1/updateClientContactTimeStep1');
const UpdateClientContactTimeStep2 = require('./steps/updateClientContactTimeStep2/updateClientContactTimeStep2');
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');

class UpdateClientContactTime extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        };

        this.handleFinish = this.handleFinish.bind(this);
        this.handleToggleCancelModal = this.handleToggleCancelModal.bind(this);
    }

    componentDidMount() {
        const { requestProfile, history } = this.props;
        requestProfile(history);
    }

    componentWillUnmount() {
        const { onResetUpdateClientContactTimeData } = this.props;
        onResetUpdateClientContactTimeData();
    }

    handleFinish() {
        const { match: { params: { contactTimeType } }, handleFinish } = this.props;
        handleFinish(contactTimeType);
    }

    handleToggleCancelModal() {
        this.setState({ showModal: !this.state.showModal });
    }

    handleCancelWizard() {
        this.props.history.push('/myprofile/edit');
    }

    onHandleGobackCustomMessageBox() {
        this.props.history.push('/myprofile/edit');
    }

    buildCustomMessageBoxSuccess() {
        const { match: { params: { contactTimeType } } } = this.props;
        const titleSuffix = contactTimeType === PHONE_CONTACT_TIME ? 'titleScheduledContactPhoneSuccess' : 'titleScheduledContactEmailSuccess';
        const title = formatText(`updateClientContactTime-${titleSuffix}`);
        const subtitle = formatText('updateClientContactTime-subtitleMessageBoxSuccess');
        const textLink = formatText('updateClientContactTime-textLinkMessageBox').toUpperCase();

        return (
            <CustomMessageBox
                icon="icon-success"
                title={title}
                subtitle={subtitle}
                textLink={textLink}
                goBackHandler={() => this.onHandleGobackCustomMessageBox()}
            />
        )
    }

    buildCustomMessageBoxFailure() {
        const title = formatText('updateClientContactTime-titleMessageBoxFailure');
        const textLink = formatText('updateClientContactTime-textLinkMessageBox').toUpperCase();

        return (
            <CustomMessageBox
                icon="icon-warning"
                title={title}
                textLink={textLink}
                goBackHandler={() => this.onHandleGobackCustomMessageBox()}
            />
        )
    }

    buildPreleaveCancelModal() {
        return (
            <PreleaveCancelModal
                isOpen={this.state.showModal}
                onCancel={() => this.handleCancelWizard()}
                onCloseModal={this.handleToggleCancelModal}
                onStayHere={this.handleToggleCancelModal}
            />
        );
    }

    buildStep1Values() {
        const { match: { params: { contactTimeType } }, immProfileFields } = this.props;

        let step1Values = {
            fromHourValue: '',
            toHourValue: '',
            title: '',
            firstMessage: ''
        };

        if (contactTimeType === EMAIL_CONTACT_TIME) {
            step1Values.title = formatText("updateClientContactTimeStep1-titleEmail");
            step1Values.firstMessage = formatText("updateClientContactTimeStep1-messageEmail");
            step1Values.fromHourValue = `${immProfileFields.getIn(['listaDispositivos', 'dispositivo', 0, 'horaDesde'], '--:--').slice(0, 5)}h`;
            step1Values.toHourValue = `${immProfileFields.getIn(['listaDispositivos', 'dispositivo', 0, 'horaHasta'], '--:--').slice(0, 5)}h`;
        } else if (contactTimeType === PHONE_CONTACT_TIME) {
            step1Values.title = formatText("updateClientContactTimeStep1-titlePhone");
            step1Values.firstMessage = formatText("updateClientContactTimeStep1-messagePhone");
            step1Values.fromHourValue = `${immProfileFields.getIn(['listaDispositivos', 'dispositivo', 1, 'horaDesde'], '--:--').slice(0, 5)}h`;
            step1Values.toHourValue = `${immProfileFields.getIn(['listaDispositivos', 'dispositivo', 1, 'horaHasta'], '--:--').slice(0, 5)}h`;
        }

        return step1Values;
    }

    buildStep2Values() {
        const { match: { params: { contactTimeType } }, immUpdateClientContactTime } = this.props;
        const immSteps = immUpdateClientContactTime.get('steps');
        const immStepOne = immSteps.get(FIRST_STEP);

        let step2Values = {
            operative: '',
            operativeResumeText: '',
            fromHourValue: `${immStepOne.get('initialContactTime') ? immStepOne.get('initialContactTime') : '--:--'}h`,
            toHourValue: `${immStepOne.get('finalContactTime') ? immStepOne.get('finalContactTime') : '--:--'}h`
        };

        if (contactTimeType === EMAIL_CONTACT_TIME) {
            step2Values.operative = formatText('operatives-updateClientContactTimeByEmail');
            step2Values.operativeResumeText = formatText('updateClientContactTimeStep2-resumeTextEmail');
        } else if (contactTimeType === PHONE_CONTACT_TIME) {
            step2Values.operative = formatText('operatives-updateClientContactTimeByPhone');
            step2Values.operativeResumeText = formatText('updateClientContactTimeStep2-resumeTextPhone');
        }

        return step2Values;
    }

    buildWizard() {
        const {
            validateStep,
            setVisibleStep,
            immUpdateClientContactTime,
            setFromTime,
            setToTime,
            validateUIStep,
        } = this.props;

        const immSteps = immUpdateClientContactTime.get('steps');

        const immStepOne = immSteps.get(FIRST_STEP);
        const immStepThree = immSteps.get(THIRD_STEP);

        const operationParams = immStepThree.toJS().operationParams;
        const visibleStep = immUpdateClientContactTime.get('visibleStep');
        const isFetching = immUpdateClientContactTime.get('isFetching');

        const invalidSecurityData = immUpdateClientContactTime.get('invalidSecurityDataError');
        const step1Values = this.buildStep1Values();
        const step2Values = this.buildStep2Values();

        const fromHourText = formatText("updateClientContactTime-fromHourText");
        const toHourText = formatText("updateClientContactTime-toHourText");

        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel: () => { },
            finish: this.handleFinish,
            cancel: this.handleToggleCancelModal
        }

        return (
            <Wizard
                viewMode={WIZARD_VERTICAL_VIEW_MODE}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}

            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    nextButtonLabel="updateClientContactTimeStep1-nextButtonLabel"
                >
                    <UpdateClientContactTimeStep1
                        immStep={immStepOne}
                        step1Values={step1Values}
                        setFromTime={setFromTime}
                        setToTime={setToTime}
                        validateUIStep={validateUIStep}
                        fromHourText={fromHourText}
                        toHourText={toHourText}
                    />
                </WizardStep>

                <WizardStep
                    position="middle"
                    omitPreviousButton={true}
                    cancelButton={true}
                    nextButtonLabel="updateClientContactTimeStep2-nextButtonLabel"
                >
                    <UpdateClientContactTimeStep2
                        step2Values={step2Values}
                        fromHourText={fromHourText}
                        toHourText={toHourText}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    omitPreviousButton={true}
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={isFetching}
                    immFinalButton="updateClientContactTime-confirmButtonText"
                >
                    <VerifyOtpStep
                        operationType={UPDATE_CLIENT_CONTACT_TIME}
                        operationParams={operationParams}
                        invalidSecurityData={invalidSecurityData}
                    />
                </WizardStep>
            </Wizard>
        )

    }

    buildContent() {
        const { immUpdateClientContactTime, immProfileFields } = this.props;
        const isFetchingProfile = immProfileFields.get('isFetching');
        const hasErrorFinish = !!immUpdateClientContactTime.get('error');
        const hasBeenSentFinish = immUpdateClientContactTime.get('hasBeenSent');
        const wizard = this.buildWizard();
        const preleaveCancelModal = this.buildPreleaveCancelModal();
        const messageBoxSuccess = this.buildCustomMessageBoxSuccess();
        const messageBoxFailure = this.buildCustomMessageBoxFailure();

        let content;

        if (isFetchingProfile) {
            content = (<LoadingSection />);
        } else if (!hasErrorFinish && hasBeenSentFinish) {
            content = messageBoxSuccess;
        } else if (hasErrorFinish && !hasBeenSentFinish) {
            content = messageBoxFailure;
        } else {
            content = (
                <div>
                    {wizard}
                    {preleaveCancelModal}
                </div>
            );
        }
        return content;
    }

    render() {
        const { match: { params: { contactTimeType } } } = this.props;
        let breadCrumbLandingText;

        if (contactTimeType === PHONE_CONTACT_TIME) {
            breadCrumbLandingText = formatText('updateClientContactTime-changeTimeContactPhone');
        }
        else if (contactTimeType === EMAIL_CONTACT_TIME) {
            breadCrumbLandingText = formatText('updateClientContactTime-changeTimeContactEmail')
        }
        const titleHeader = formatText('updateClientContactTime-titleHeader');
        const content = this.buildContent();
        const breadCrumbMap = [
            {
                text: titleHeader,
                url: '/myprofile/edit'
            },
            {
                text: breadCrumbLandingText,
            },
        ];

        return (
            <section className="update-client-contact-time">
                <OKHeaderCC
                    title={titleHeader}
                    breadcrumbConfig={breadCrumbMap}
                    showBreadBrumb={true}
                />
                <div className="update-client-contact-time__body">
                    {content}
                </div>
            </section>
        );
    }
}

UpdateClientContactTime.propTypes = {
    match: PropTypes.object.isRequired,
    immUpdateClientContactTime: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    validateStep: PropTypes.func.isRequired,
    validateUIStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    onResetUpdateClientContactTimeData: PropTypes.func.isRequired,
    setFromTime: PropTypes.func.isRequired,
    setToTime: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
}

module.exports = withRouter(UpdateClientContactTime);
